import React, { useEffect, useRef, useState } from "react";
// import "";
import SkeletonLoader from "../SkeletonLoader/SkeletonLoader";
import { useLocation, useParams } from "react-router-dom";

function PackagesStateInputNewUi({ onDataChange, disableSearchInput, width }) {
  const [SearchState, setSearchState] = useState([]);
  const [selectedState, setSelectedState] = useState("");

  const [resultArray, setResultArray] = useState([]);

  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setResultArray([]);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchDestination = async (destination) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/destinations/fetch`,
        requestOptions
      );

      const result = await response.json();

      if (result.success) {
        setSearchState(result?.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      SkeletonLoader(false);
    }
  };

  useEffect(() => {
    fetchDestination();
  }, []);

  const handleOnStateChange = (e) => {
    setSelectedState(e.target.value);
    const { value } = e.target;
    const filteredArray = SearchState.filter((item) =>
      item?.name?.toLowerCase()?.includes(value?.toLowerCase())
    );
    setResultArray(filteredArray);
  };

  // onDataChange(selectedState, resultArray);
  useEffect(() => {
    onDataChange(selectedState, resultArray);
  }, [selectedState, resultArray]);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const data = {
      location: params.get("location"),
      startdestination: params.get("startdestination"),
    };
    if (data.location) {
      setSelectedState(data.location);
    } else {
      setSelectedState(data.startdestination);
    }

    // postBookingData(data);
  }, [location.search]);

  return (
    <>
      {width <= 640 ? (
        <div
          className="search-location-input relative"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width:"100%"
          }}
        >
          <input
            className="testform_input pac-target-input"
            value={selectedState}
            onChange={handleOnStateChange}
            required
            disabled={disableSearchInput}
            style={{ border: 0, outline: 0, position: "relative" }}
            placeholder="Where would you like to go?"
          />

          <span style={{ marginBottom: "5px" }}>
            <svg
              style={{ margin: "0" }}
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 13 16"
              fill="none"
            >
              <path
                d="M6.5013 7.89894C6.87443 7.89894 7.19343 7.76606 7.4583 7.50031C7.7233 7.23456 7.8558 6.91512 7.8558 6.542C7.8558 6.16887 7.72293 5.84981 7.45718 5.58481C7.19143 5.31994 6.87193 5.1875 6.49868 5.1875C6.12555 5.1875 5.80655 5.32038 5.54168 5.58613C5.27668 5.85188 5.14418 6.17138 5.14418 6.54463C5.14418 6.91775 5.27705 7.23675 5.5428 7.50163C5.80855 7.7665 6.12805 7.89894 6.5013 7.89894ZM6.49999 13.6351C7.96724 12.3216 9.09005 11.0618 9.86843 9.8555C10.6468 8.64925 11.036 7.59275 11.036 6.686C11.036 5.31875 10.6016 4.19475 9.73286 3.314C8.86411 2.43325 7.78649 1.99287 6.49999 1.99287C5.21349 1.99287 4.13586 2.43325 3.26711 3.314C2.39836 4.19475 1.96399 5.31875 1.96399 6.686C1.96399 7.59275 2.35318 8.64925 3.13155 9.8555C3.90993 11.0618 5.03274 12.3216 6.49999 13.6351ZM6.49999 15.1321C4.61249 13.4966 3.19711 11.9746 2.25386 10.5659C1.31061 9.15719 0.838989 7.86387 0.838989 6.686C0.838989 4.95525 1.3988 3.55406 2.51843 2.48244C3.63818 1.41081 4.96536 0.875 6.49999 0.875C8.03461 0.875 9.3618 1.41081 10.4816 2.48244C11.6012 3.55406 12.161 4.95525 12.161 6.686C12.161 7.86387 11.6894 9.15719 10.7461 10.5659C9.80286 11.9746 8.38749 13.4966 6.49999 15.1321Z"
                fill="#1C1B1F"
              />
            </svg>
          </span>

          {resultArray?.length > 0 && (
            <div className="search_list" ref={dropdownRef}>
              {resultArray?.map((state, index) => (
                <div
                  key={index}
                  onClick={() => [
                    setSelectedState(state?.name),
                    setResultArray([]),
                  ]}
                >
                  <span>{state?.name}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div
          className="search-location-input relative"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width:"100%"
            // flexDirection:"row-reverse"
          }}
        >
          <span style={{ marginBottom: "5px" }}>
            <svg
              style={{ margin: "0" }}
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 13 16"
              fill="none"
            >
              <path
                d="M6.5013 7.89894C6.87443 7.89894 7.19343 7.76606 7.4583 7.50031C7.7233 7.23456 7.8558 6.91512 7.8558 6.542C7.8558 6.16887 7.72293 5.84981 7.45718 5.58481C7.19143 5.31994 6.87193 5.1875 6.49868 5.1875C6.12555 5.1875 5.80655 5.32038 5.54168 5.58613C5.27668 5.85188 5.14418 6.17138 5.14418 6.54463C5.14418 6.91775 5.27705 7.23675 5.5428 7.50163C5.80855 7.7665 6.12805 7.89894 6.5013 7.89894ZM6.49999 13.6351C7.96724 12.3216 9.09005 11.0618 9.86843 9.8555C10.6468 8.64925 11.036 7.59275 11.036 6.686C11.036 5.31875 10.6016 4.19475 9.73286 3.314C8.86411 2.43325 7.78649 1.99287 6.49999 1.99287C5.21349 1.99287 4.13586 2.43325 3.26711 3.314C2.39836 4.19475 1.96399 5.31875 1.96399 6.686C1.96399 7.59275 2.35318 8.64925 3.13155 9.8555C3.90993 11.0618 5.03274 12.3216 6.49999 13.6351ZM6.49999 15.1321C4.61249 13.4966 3.19711 11.9746 2.25386 10.5659C1.31061 9.15719 0.838989 7.86387 0.838989 6.686C0.838989 4.95525 1.3988 3.55406 2.51843 2.48244C3.63818 1.41081 4.96536 0.875 6.49999 0.875C8.03461 0.875 9.3618 1.41081 10.4816 2.48244C11.6012 3.55406 12.161 4.95525 12.161 6.686C12.161 7.86387 11.6894 9.15719 10.7461 10.5659C9.80286 11.9746 8.38749 13.4966 6.49999 15.1321Z"
                fill="#1C1B1F"
              />
            </svg>
          </span>

          <input
            className="testform_input pac-target-input"
            value={selectedState}
            onChange={handleOnStateChange}
            required
            disabled={disableSearchInput}
            style={{ border: 0, outline: 0, position: "relative" }}
            placeholder="Where would you like to go?"
          />

          {resultArray?.length > 0 && (
            <div className="search_list" ref={dropdownRef}>
              {resultArray?.map((state, index) => (
                <div
                  key={index}
                  onClick={() => [
                    setSelectedState(state?.name),
                    setResultArray([]),
                  ]}
                >
                  <span>{state?.name}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default PackagesStateInputNewUi;
